/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {Block} from 'baseui/block'
import {Heading, HeadingLevel} from 'baseui/heading'
import React from 'react'

const PageScaffold = ({children, pageTitle = ''}) => {
  return (
    <Block
      $as="main"
      overrides={{
        Block: {
          style: ({$theme}) => ({
            flexBasis: '63%',
            width: '100%',
          }),
        },
      }}
    >
      <Block
        overrides={{
          Block: {
            style: ({$theme}) => ({
              marginLeft: 'auto',
              marginRight: 'auto',
              marginBottom: $theme.sizing.scale800,
              maxWidth: '60rem',
            }),
          },
        }}
      >
        <Block $as="header">
          <HeadingLevel>
            <Heading
              styleLevel={4}
              overrides={{
                Block: {
                  style: ({$theme}) => ({
                    // color: $theme.colors.mono500,
                    fontWeight: 900,
                    textTransform: 'uppercase',
                  }),
                },
              }}
            >
              {pageTitle}
            </Heading>
          </HeadingLevel>
        </Block>
        {children}
      </Block>
    </Block>
  )
}

export default PageScaffold
